import React from "react";
var __jsx = React.createElement;
import loadable from "@loadable/component";
import { useLang } from "@/common/Contexts/LanguageContext";
import dataVideosAll from "@data/videos/data.json";
import { useEffect } from "react";
import useIsWebView from "@hooks/useIsWebview";
var fallback = {
  fallback: null
};
export var VideoEmbed = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "_MiniApps-VideoRenderer-Video";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "_MiniApps-VideoRenderer-Video" */"@/_MiniApps/VideoRenderer/Video");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/_MiniApps/VideoRenderer/Video");
    }
    return eval('require.resolve')("@/_MiniApps/VideoRenderer/Video");
  }
}, fallback);
export var VideoRenderer = function VideoRenderer() {
  var _dataVideosAll$lang;
  if (__IS_SSR__) return null;
  var lang = useLang();
  var dataVideo = (dataVideosAll === null || dataVideosAll === void 0 ? void 0 : (_dataVideosAll$lang = dataVideosAll[lang]) === null || _dataVideosAll$lang === void 0 ? void 0 : _dataVideosAll$lang[0]) || null;
  var today = new Date();
  var isWebView = useIsWebView();
  useEffect(function () {
    var endDate = new Date(dataVideo === null || dataVideo === void 0 ? void 0 : dataVideo.campaign_end_date);
    if (today > endDate) return;
  }, []);
  if (!dataVideo || !(dataVideo !== null && dataVideo !== void 0 && dataVideo.video_url_desktop)) return;
  if (isWebView) return null;
  return /*#__PURE__*/React.createElement(VideoEmbed, {
    campaign_key: dataVideo === null || dataVideo === void 0 ? void 0 : dataVideo.campaign_key,
    desktopVideoUrl: dataVideo === null || dataVideo === void 0 ? void 0 : dataVideo.video_url_desktop,
    mobileVideoUrl: dataVideo === null || dataVideo === void 0 ? void 0 : dataVideo.video_url_mobile,
    excludedPages: dataVideo === null || dataVideo === void 0 ? void 0 : dataVideo.excluded_pages_urls,
    maxViews: dataVideo === null || dataVideo === void 0 ? void 0 : dataVideo.max_views,
    campaignEndDate: dataVideo === null || dataVideo === void 0 ? void 0 : dataVideo.campaign_end_date,
    cookie_days: dataVideo === null || dataVideo === void 0 ? void 0 : dataVideo.cookie_days,
    cta: dataVideo.cta
  });
};